import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {SimplifiedCompany} from '../../models/SimplifiedCompany';

@Component({
  selector: 'app-electricity-contract-actions',
  templateUrl: './contract-actions.component.html',
  styleUrls: ['./contract-actions.component.scss']
})
export class ContractActionsComponent implements OnInit {

  @Input()
  public rowData: any;

  @Input()
  public value: any;

  public hasUserRights: boolean;

  @Output()
  public changeSupplier: EventEmitter<any> = new EventEmitter<any>();
  @Output()
  public sendIndex: EventEmitter<any> = new EventEmitter<any>();
  @Output()
  public cancelContract: EventEmitter<any> = new EventEmitter<any>();
  @Output()
  public quitMenu: EventEmitter<any> = new EventEmitter<any>();

  constructor() { }

  ngOnInit(): void {
    if (this.value.company) {
      const permissions = this.value.company.permissionsDTO;
      this.hasUserRights = permissions.isOwner || permissions.canChangeSupplierContract;
    }
  }

  public changeSupplierAction(): void {
    this.changeSupplier.emit(this.rowData);
  }

  public sendIndexAction(): void {
    this.cancelContract.emit(this.rowData);
  }

  public quitMenuAction(): void {
    this.quitMenu.emit(this.rowData);
  }

}
